var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreflight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33331 22.6667V8.00001C1.33331 7.26668 1.59442 6.6389 2.11665 6.11668C2.63887 5.59445 3.26665 5.33334 3.99998 5.33334H22.6666V10.6667H26.6666L30.6666 16V22.6667H27.4235C27.4233 24.5245 25.9172 26.0306 24.0593 26.0306C22.2014 26.0306 20.6953 24.5245 20.6951 22.6667H11.3639C11.3638 24.5244 9.85775 26.0304 7.99998 26.0304C6.14221 26.0304 4.63618 24.5244 4.63605 22.6667H1.33331ZM22.6666 17.3333H28.3333L25.3333 13.3333H22.6666V17.3333Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreflight);
export default __webpack_public_path__ + "static/media/preflight.d4aac9b597509b2e8f24dc9a034c2e84.svg";
export { ForwardRef as ReactComponent };